import { RequestsInstance } from 'api';
import { AxiosRequestConfig } from 'axios';

const SportsApiWrapper = (requests: RequestsInstance) => {
	return {
		getSportDataByCategoryId: (id: number, filter: string | undefined, config: AxiosRequestConfig = {}) => {
			return requests.get(`/market/categories/${id}/events`, {
				params: { filter },
				...config,
			});
		},
	};
};

export default SportsApiWrapper;
